import { FormattedMessage } from 'react-intl';

import { HeadlineS } from '@sorare/core/src/atoms/typography';
import { ListWithDetailLayout } from '@sorare/core/src/components/layout/ListWithDetailLayout';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

import { MissionsCategorySelector } from '#src/pages/MissionsPageLayout/MissionsCategorySelector/index.tsx';

const MissionsLayout = () => {
  const { sport } = useSportContext();
  const isDesktopAndAbove = useIsDesktopAndAbove();

  return (
    <>
      <PageHeader
        backTo={generateSportPath(ANY_SPORT_HOME, {
          sport,
        })}
        customTitle={
          <HeadlineS>
            <FormattedMessage
              id="MissionsPage.title"
              defaultMessage="Missions"
            />
          </HeadlineS>
        }
      />
      <ListWithDetailLayout noPadding forceNoMobileDialog>
        {!!isDesktopAndAbove && <MissionsCategorySelector sport={sport} />}
      </ListWithDetailLayout>
    </>
  );
};

export default MissionsLayout;
